import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import ImageDisplay from '../../../components/manageimage/ImageDisplay';
import { Modal } from "react-bootstrap";
import { Button, Dropdown, Breadcrumb } from 'react-bootstrap';
import Preloader from "../../../components/Preloader/Preloader";
import AddSlider from './AddSlider';
import { ProductContext } from '../../../ProductProvider';
import { useSnackbar } from 'notistack';
import { Link } from 'react-router-dom';
import logo from '../../../assets/images/logo/logo.png';
import './SliderViewer.css'

const config = require('../../../config.json');

export default function SliderViewer() {
    const { validateLogin, loggedUser, generateUniqueId } = useContext(ProductContext);
    const [loaded, setLoaded] = useState(false);
    const [galleryImages, setGalleryImages] = useState('');
    const [collapsed, setCollapsed] = useState(false);
    const [imageFile, setImageFile] = useState([]);
    const [profileImage, setProfileImage] = useState(logo);
    const [newFileName, setNewFileName]=useState('');
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if(loggedUser.isAuthenticated){
            fetchGalleryImages();  
        }else{
            validateLogin();
        }
    }, [loggedUser]);

    const handleDeleteImage = async(event, imageName)=>{
        event.preventDefault();
        setLoaded(false);
       try{
           if(galleryImages.length<2){
            enqueueSnackbar("Delete not allowed! Only one image left in Slider",{variant : 'info'});
           }else{
            const { idToken } = (await fetchAuthSession()).tokens ?? {};
            //console.log("image : ", imageName  );
            await axios.get(`${config.api.invokeURL}/dashboard/website/gallery/remove?imageName=${imageName}`,{
            //await axios.get(`${config.api.invokeURL}/dashboard/website/gallery/remove?imageName=${imageName}`,{
            headers:{
                Authorization: idToken,
                'x-api-key': config.api.key
            }
        }).then((response)=>{
            enqueueSnackbar("Deleted Successfully!",{variant : 'success'});
            window.scrollTo(0,0);
            fetchGalleryImages();
        }).catch((error)=>{
           enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
            setLoaded(true);
            window.scrollTo(0,0); 
        })
    }
    }catch(error){
        enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        setLoaded(true);
        window.scrollTo(0,0); 
    }
    setLoaded(true);
    }

    const toggle = () => {
          setCollapsed(!collapsed);
    }

     const fetchGalleryImages =async()=>{
        try{
            setLoaded(false);
        const fileName='images/slider';
        const bucketName=config.s3.bucketName;
      await axios.get(`${config.api.invokeURL}/dashboard/website/slider?fileName=${fileName}&bucketName=${bucketName}`,{
            headers: {
              //Authorization: access_token,
              'x-api-key': config.api.key
            }}, 
        ).then((response)=>{
            console.log("Response : ", response);
            const finalList=[];
            if(response.data.length>0){
              for (const i in response.data){
                const tValue=response.data[i];
                const tPathName=tValue.split("/");
                const tBreakUp=tPathName[2];
                const tempValue={};
                tempValue.fullPathName=response.data[i];
                tempValue.fileName=tBreakUp;
               // const tdoctorName=tBreakUp[1];
               // const tempDName=tdoctorName.split(".");
               // tempValue.doctorName=tempDName[0];
               // console.log("tempvalue : ", tempValue);
               // tempValue.projectSize=tBreakUp[2];
                //tempValue.projectDate=tBreakUp[3];
                finalList.push(tempValue);
              }
            }
      
           // console.log(finalList);
            setGalleryImages(finalList);
            //setDispMsg(response.data.length + " - Images are found in your Gallery");
            enqueueSnackbar(response.data.length + " - Images are found in Slider section",{variant : 'success'});
            setLoaded(true);
            window.scrollTo(0,0); 
        }).catch((error)=>{
            console.log(error.message);
            //setDispMsg(error.message);
            enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
            setLoaded(true);
            window.scrollTo(0,0); 
        })
    }catch(error){
       // setDispMsg(error.message);
        enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        setLoaded(true);
        window.scrollTo(0,0); 
    }
    setLoaded(true);
}


    /*const fetchGalleryImages =async()=>{
        try{
            setLoaded(false);
            const { idToken } = (await fetchAuthSession()).tokens ?? {};
          //const fileName='images/gallery/';
         // const bucketName="images.stjosephhospitaldindigul.in";
      //await axios.get(`${config.api.invokeUrl}/images/gallery?fileName=${keyName}&bucketName=${bucketName}`,{
        //const fileName='images/doctor/';
        const fileName='images/slider';
        const bucketName="images.stxaviersthoothukudi.com";
      await axios.get(`${config.api.invokeURL}/dashboard/website/slider?fileName=${fileName}&bucketName=${bucketName}`,{
            headers: {
             // Authorization: access_token,
              'x-api-key': config.api.key
            }}, 
        ).then((response)=>{
            console.log("Response : ", response);
            const finalList=[];
            if(response.data.length>0){
              for (const i in response.data){
                const tValue=response.data[i];
                const tPathName=tValue.split("/");
                const tBreakUp=tPathName[2];
                const tempValue={};
                tempValue.fullPathName=response.data[i];
                tempValue.fileName=tBreakUp;
                finalList.push(tempValue);
              }
            }
            setGalleryImages(finalList);
            enqueueSnackbar(response.data.length + " - Images are found in Slider section",{variant : 'success'});
            setLoaded(true);
            window.scrollTo(0,0); 
        }).catch((error)=>{
            enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
            setLoaded(true);
            window.scrollTo(0,0); 
        })
    }catch(error){
       enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        setLoaded(true);
        window.scrollTo(0,0); 
    }
    setLoaded(true);
    }*/

/*const addImageOnS3=async()=>{
    try{ 
        setLoaded(false);
      
        const fileName=projectName+"_"+new Date().getTime();
      const newFileName=fileName+".jpeg";
      const bucketName=config.s3.bucketName+keyName;
      //console.log("bucket name : ", bucketName);
      //console.log("file name : ", newFileName);

      var file = imageFile;
      var blob = file.slice(0, file.size, 'image/jpeg'); 
      const newFile = new File([blob], newFileName, {type: 'image/jpeg'});
      //console.log("New file : ", newFile);
      const session = await Auth.currentSession();
      const access_token=session.idToken.jwtToken;
      //console.log("access token : ", access_token);
      await axios.get(`${config.api.invokeURL}/images/presigned?fileName=${newFileName}&bucketName=${bucketName}`,{
           headers:{
              Authorization: access_token,
              'x-api-key': config.api.key
           }
       }).then(async(response)=>{
           console.log("Response : ", response);
          const res=await fetch(response.data.uploadURL, { method: 'PUT',
           headers:{
               "Content-Type":"image/jpeg"
             },body: newFile});
            // console.log("Res : ", res);
             if(res.status===200){
                fetchGalleryImages();
                 setProfileImage(newFileName);
                 //var timestamp = new Date().getTime();     
                 var tprofile = document.getElementById("profile");
                 //var imgsrc="";
                 //imgsrc=imgsrc.concat(config.s3.imageURL,newFileName,"?t=",timestamp);     
                 //tprofile.src=`${config.s3.imageURL}${newFileName}`+"?t="+timestamp;
                // tprofile.src=imgsrc;
                tprofile.src="https://s3.ap-south-1.amazonaws.com/idntica.com/avatar/profileImage/defaultAvatar.jpeg";
                 //console.log("tprofle : ", tprofile.src);
                 toggle();

             }
        }).catch((error)=>{
            //console.log("error1:", error);
            setAlertDetails({
                ...alertDetails,
                style:"warning",
                open:true,
                message:"Error Occured - " + error.message
            }); 
            setLoaded(true);
            window.scrollTo(0,0);   
         // setDispMsg(error.message);
         // hideLoader();
       })
    }catch(error){
      //console.log("error1:", error);
      setAlertDetails({
        ...alertDetails,
        style:"warning",
        open:true,
        message:"Error Occured - " + error.message
    }); 
    setLoaded(true);
    window.scrollTo(0,0);   
    }
    setLoaded(true);

}*/


    const   handleImageUploads = async(event) => {
        event.preventDefault();
        // Handle image upload logic here
        var i = 0;
        while (i < imageFile.length) {
            //console.log("Image File : ", imageFile[i]);
            await postOnS3(event, imageFile[i]);
            i++;
        }
        await fetchGalleryImages();
       // handleCloseImageAdd(event);
        setImageFile([]);
    }


    const postOnS3 = async(event, imageFile)=>{
    event.preventDefault();
    try{ 
        if(imageFile==="")
        {
            enqueueSnackbar("Select the file for upload!",{variant : 'info'});
            setLoaded(true);
            window.scrollTo(0,0);   

        }else{
        setLoaded(false);
        //const fileName=newFileName
        const tempName=generateUniqueId();
        const tnewFileName=tempName+".jpeg";
        const keyName='images/slider';

        const bucketName=config.s3.bucketName;
      var file = imageFile;
      var blob = file.slice(0, file.size, 'image/jpeg'); 
      const newFile = new File([blob], tnewFileName, {type: 'image/jpeg'});
      //console.log("New file : ", newFile);
      const { idToken } = (await fetchAuthSession()).tokens ?? {};
      const fileType="image/jpeg";

      //console.log("access token : ", access_token);
      await axios.get(`${config.api.invokeURL}/dashboard/image/presigned/uploader?fileName=${tnewFileName}&bucketName=${bucketName}&keyName=${keyName}&fileType=${fileType}`,{
        //await axios.get(`${config.api.invokeURL}/admin/images/presigned?fileName=${tnewFileName}&bucketName=${bucketName}`,{
           headers:{
              Authorization: idToken,
              'x-api-key': config.api.key
           }
       }).then(async(response)=>{
           console.log("Response : ", response);
          const res=await fetch(response.data.uploadURL, { method: 'PUT',
           headers:{
               "Content-Type":"image/jpeg"
             },body: newFile});
             console.log("Res : ", res);
             if(res.status===200){
               // fetchGalleryImages();
                 toggle();
             }
        }).catch((error)=>{
            console.log("Error Occured : ", error);
            enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
            setLoaded(true);
            window.scrollTo(0,0);   
       })
    }
    }catch(error){
        console.log("Error 2 Occured : ", error);
      enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
      setLoaded(true);
      window.scrollTo(0,0);   
    }
    setLoaded(true);
    }

    return (
    <div> 
        <main id="main" className="main">
        <div className="slider-hero">
           
        </div>
    <Preloader show={loaded ? false : true} />
        <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/">
          <i className="bi bi-house" aria-hidden="true"></i>
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item >
          Slider
        </Breadcrumb.Item>
        </Breadcrumb>
            <div className="title"><h3>Slider</h3></div>

         <div className="slider-actions">
                <Dropdown>
                    <Dropdown.Toggle as={Button} onClick={(event)=>{toggle(event)}} variant="secondary" className="text-dark me-2">
                        <i className="bi bi-plus" aria-hidden="true"></i>
                        <span>New</span>
                    </Dropdown.Toggle>
                </Dropdown>
            </div>
    
    {/* Add Doctor Images */}
    <Modal size="lg" show={collapsed} onHide={toggle}>
    <Modal.Header toggle={toggle} closeButton>
        Add images            
    </Modal.Header>
    <Modal.Body>
        <AddSlider setNewFileName={setNewFileName} setImageFile={setImageFile} profileImage={profileImage} />
    </Modal.Body>
    <Modal.Footer>
    <Button
    color="primary"
    onClick={(event)=>handleImageUploads(event)}
    >
    Add Image
    </Button>
    {' '}
    <Button onClick={toggle}>
    Cancel
    </Button>
    </Modal.Footer>
    </Modal>
 
        <div className="slider-container">
            {galleryImages.length>0 ? (
                <div className="slider-grid">
                    {galleryImages.map((images, index) => {
                        const imgUrl = `${config.s3.imageUrl}${images.fullPathName}?t=${new Date().getTime()}`;
                        return (
                            <div className="slide-card" key={images.fileName}>
                                <img src={imgUrl} alt={images.fileName} onError={() => setProfileImage(logo)} />
                                <div className="slide-meta">
                                    <div className="slide-title">{images.fileName}</div>
                                </div>
                                <div className="overlay">
                                    <button className="btn btn-sm btn-light" onClick={(e)=>handleDeleteImage(e, images.fullPathName)} title="Delete">
                                        <i className="bi bi-trash-fill"></i>
                                    </button>
                                </div>
                            </div>
                        )
                    })}
                </div>
            ) : (
                <div className="empty-message">No images found in the Slider</div>
            )}
        </div>
    </main>
    </div>
    )
}
